import styled from "@emotion/styled";
import {motion} from "framer-motion";

import {ReactNode} from "react";
import Content from "./Content";
import Header from "./Header";
import Title from "./Title";
import Footer from "./Footer";


const PageContainer = styled(motion.div)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: white;    
`;

export const pageVariants = {
    init: {opacity: 0},
    open: {opacity: 1},
    exit: {opacity: 0},
};

interface Props {
    children: ReactNode;
}

const Page = ({children}: Props) => {
    return (
        <PageContainer variants={pageVariants} initial={"init"} animate={"open"} exit={"init"}>
            {children}
        </PageContainer>
    );
};

Page.Header = Header;
Page.Content = Content;
Page.Title = Title;
Page.Footer = Footer;

export default Page;
